import React, { useContext } from "react";
import { Route, Routes, useParams, useNavigate } from "react-router-dom";
import WorkExchange from "../../components/WorkExchange";
import WorkExchangeSub from "../../components/WorkExchange/View";
import "../../styles/workExchange.scss";
import WorkExchangeMain from "../../components/WorkExchange/Main";
import WorkExchangeCategory from "../../components/WorkExchange/Category";

const WorkExchangePage = () => {
  const Sub = () => {
    const { id } = useParams();
    return <WorkExchangeSub id={id} />;
  };

  return (
    <Routes>
      <Route path="" element={<WorkExchangeMain />} />
      <Route path=":id" element={<WorkExchangeCategory />} />
    </Routes>
  );
};

WorkExchangePage.propTypes = {};

export default WorkExchangePage;
